export const packingWorkspaceEn = {
 packing_lot_required:"Enter the actual LOT for every P-Process line before creating a delivery note.",
  edit: "Edit packing list",
  preview: "Saved packing list · Print preview",
  archive: "Archive packing list",
  choosePi: "Choose source PI",
  allocatedElsewhere: "Other packing lists",
  availabilityError:
    "Could not load current packing allocations. Retry before adding more items.",
  unweighed:
    "Some cartons have not been weighed. Blank means unknown, not zero. Complete weights before dispatch.",
  resolveConflicts:
    "Carton rows contain inconsistent weights or dimensions. I have reviewed the displayed carton values and agree to apply them to every row when saving.",
  quantityByUnit: "Quantity by unit",
  deliveryReview:
    "Review the saved recipient, cartons, quantities and LOTs below. This opens an existing related delivery note or creates one from these saved details.",
  from: "Packing date from",
  to: "Packing date to",
  operations: "Shipment overview",
  packing_source_invalid:
    "The line does not belong to this PI, or its saved reference changed. Choose a valid source line.",
  packing_identity_locked:
    "Code, Sub Ref and unit come from the PI and cannot be changed on a linked packing line.",
  packing_weight_invalid:
    "Gross weight must be at least net weight. Enter valid non-negative weights.",
  packing_empty: "Add at least one carton containing an item.",
  packing_delivery_locked:
    "Related delivery notes exist. Review or archive them before editing or archiving this packing list.",
  packing_invoice_invalid:
    "The invoice must be the active invoice of this source PI, or remain blank.",
  packing_retry_conflict:
    "This request was already used with different data. Reload the saved result before retrying.",
  packing_changed:
    "The packing list changed while you were working. Reload and review the latest data.",
  packing_carton_conflict:
    "Review and confirm the inconsistent carton weights and dimensions before saving line changes.",
  packing_invoice_delivery_exists:
    "A delivery note was already created directly from this invoice. Review it before creating another shipment.",
};
export const packingWorkspaceVi = {
 packing_lot_required:"Nhập LOT thực tế cho mọi dòng P-Process trước khi tạo phiếu giao hàng.",
  edit: "Sửa phiếu đóng gói",
  preview: "Phiếu đã lưu · Xem trước bản in",
  archive: "Lưu trữ phiếu đóng gói",
  choosePi: "Chọn PI nguồn",
  allocatedElsewhere: "Đã đóng ở phiếu khác",
  availabilityError:
    "Chưa tải được lượng đã phân bổ. Thử lại trước khi thêm hàng.",
  unweighed:
    "Một số thùng chưa được cân. Ô trống là chưa biết, không phải 0. Hoàn tất trọng lượng trước khi giao.",
  resolveConflicts:
    "Các dòng cùng thùng có trọng lượng hoặc kích thước khác nhau. Tôi đã kiểm tra các giá trị đang hiển thị và đồng ý áp dụng cho mọi dòng khi lưu.",
  quantityByUnit: "Số lượng theo đơn vị",
  deliveryReview:
    "Kiểm tra người nhận, thùng, số lượng và LOT đã lưu. Thao tác sẽ mở phiếu giao hàng liên quan đang có hoặc tạo phiếu từ nội dung đã lưu này.",
  from: "Ngày đóng gói từ",
  to: "Ngày đóng gói đến",
  operations: "Tổng quan lô hàng",
  packing_source_invalid:
    "Dòng hàng không thuộc PI này hoặc tham chiếu đã thay đổi. Chọn dòng nguồn hợp lệ.",
  packing_identity_locked:
    "Code, Sub Ref và đơn vị lấy từ PI, không thể đổi trên dòng đóng gói đã liên kết.",
  packing_weight_invalid:
    "Trọng lượng cả bì phải lớn hơn hoặc bằng trọng lượng tịnh. Nhập số không âm hợp lệ.",
  packing_empty: "Thêm ít nhất một thùng có hàng.",
  packing_delivery_locked:
    "Đã có phiếu giao hàng liên quan. Kiểm tra hoặc lưu trữ chúng trước khi sửa hoặc lưu trữ phiếu đóng gói.",
  packing_invoice_invalid:
    "Hóa đơn phải thuộc đúng PI nguồn và đang hoạt động, hoặc để trống.",
  packing_retry_conflict:
    "Yêu cầu này đã được dùng với dữ liệu khác. Tải lại kết quả đã lưu trước khi thử tiếp.",
  packing_changed:
    "Phiếu đóng gói đã thay đổi trong lúc bạn thao tác. Tải lại và kiểm tra bản mới nhất.",
  packing_carton_conflict:
    "Kiểm tra và xác nhận trọng lượng/kích thước không nhất quán trước khi lưu dòng hàng.",
  packing_invoice_delivery_exists:
    "Đã có phiếu giao hàng tạo trực tiếp từ hóa đơn này. Kiểm tra phiếu đó trước khi tạo lô giao khác.",
};
export const packingWorkspaceZh = {
 packing_lot_required:"创建送货单前，请为每个 P-Process 明细填写实际 LOT。",
  edit: "编辑装箱单",
  preview: "已保存装箱单 · 打印预览",
  archive: "归档装箱单",
  choosePi: "选择来源 PI",
  allocatedElsewhere: "其他装箱单已分配",
  availabilityError: "无法加载目前分配量。新增明细前请重试。",
  unweighed: "部分箱尚未称重。空白表示未知而非零。出货前请补全重量。",
  resolveConflicts:
    "同箱明细的重量或尺寸不一致。我已核对显示值，并同意保存时应用到该箱所有明细。",
  quantityByUnit: "按单位汇总数量",
  deliveryReview:
    "请核对已保存的收件人、箱数、数量和 LOT。将打开现有送货单或依此数据创建新单据。",
  from: "装箱起始日期",
  to: "装箱结束日期",
  operations: "出货总览",
  packing_source_invalid: "明细不属于此 PI 或参照已更改。请选择有效来源明细。",
  packing_identity_locked:
    "代码、子参考及单位来自 PI，无法在已关联装箱明细中更改。",
  packing_weight_invalid: "毛重不得低于净重。请输入有效非负重量。",
  packing_empty: "请至少新增一个含明细的箱。",
  packing_delivery_locked:
    "已有相关送货单。修改或归档装箱单前，请先查看或归档送货单。",
  packing_invoice_invalid: "发票必须是来源 PI 的有效发票，或保持空白。",
  packing_retry_conflict: "此请求已用于不同数据。重试前请重新加载已保存结果。",
  packing_changed: "操作期间装箱单已更改。请重新加载并核对最新数据。",
  packing_carton_conflict: "保存明细前请核对并确认不一致的箱重及尺寸。",
  packing_invoice_delivery_exists:
    "此发票已直接创建送货单。创建另一批出货前请先核对。",
};
